export const formatFormCta = (finalPage: boolean, isSubmitting: boolean) => {
  if (!finalPage) {
    return 'Next'
  }

  return isSubmitting ? 'Submitted' : 'Submit'
}
